<div class="bar-chart" id="histogram{{pageTab}}{{index}}"></div>
